var __default__ = {root:'m_1b7284a3'};
export default __default__;